






import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

/**
 * "id" has to be a value in initial state of app.loadingData array.
 */
@Component
export default class Loading extends Vue {
  @Prop({ type: String, default: 'primary' }) variant!: string
}
